"use client";

import { GoogleTagManager } from "@next/third-parties/google";
import { useEffect, useState } from "react";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export function GoogleTagManagerProvider() {
  const [shouldLoadGTM, setShouldLoadGTM] = useState(false);

  useEffect(() => {
    // Optimized: Lazy load GTM after 3 seconds to reduce initial CPU load
    const timer = setTimeout(() => {
      setShouldLoadGTM(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!GTM_ID) {
    return null;
  }

  // Only render GTM after delay to reduce CPU usage during critical app initialization
  if (!shouldLoadGTM) {
    return null;
  }

  return <GoogleTagManager gtmId={GTM_ID} />;
}
